"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "EXTRA_STATUSES", {
  enumerable: true,
  get: function get() {
    return _TicketStatus.EXTRA_STATUSES;
  }
});
Object.defineProperty(exports, "STATUSES", {
  enumerable: true,
  get: function get() {
    return _TicketStatus.STATUSES;
  }
});
Object.defineProperty(exports, "TITLES", {
  enumerable: true,
  get: function get() {
    return _TicketStatus.TITLES;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TicketStatus["default"];
  }
});
var _TicketStatus = _interopRequireWildcard(require("./TicketStatus"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }